const dispatch = require("~/store.js").dispatch;

const server = require("~/server.js");

const events = require("./reportEvents.js");

const reportDispatchers = {
    RegionSelectionsChanged(audit, division, district, dateRange) {
        const changed = events.RegionSelectionsChanged.New(audit, division, district, dateRange);

        dispatch(changed);
    },
    AuditSelectionChanged(audit) { 
        const changed = events.AuditSelectionChanged.New(audit);

        dispatch(changed); 
    },
    LoadingCompleteReport(loading) { 
        const changed = events.LoadingCompleteReport.New(loading); 

        dispatch(changed); 
    }, 
    GetValidAuditPeriods() { 
        dispatch((thunkDispatch) => {

            const loading = events.GetValidAuditPeriods.New();

            thunkDispatch(loading);

            const url = `reports/audit-periods`;

            server.Get(url)
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    const loaded = events.GotValidAuditPeriods.New(json);

                    thunkDispatch(loaded);
                })
                .catch((ex) => {
                    const errored = events.ErroredValidAuditPeriods.New(ex);

                    thunkDispatch(errored);
                });
        }); 
    },
    GetCompletionReport(divisionNumber, auditType, dateRange) { 
        dispatch((thunkDispatch) => {

            const loading = events.GetCompletionReport.New();

            thunkDispatch(loading);

            const url = `reports/audit-reporting?divisionNumber=${divisionNumber}&AuditType=${auditType}&DateRange=${dateRange}`;

            server.Get(url)
                .then((response) => {
                    return response.json(); 
                })
                .then((json) => {
                    const loaded = events.GotCompletionReport.New(json);

                    thunkDispatch(loaded); 
                })
                .catch((ex) => {
                    const errored = events.ErroredGetCompletionReport.New(ex);

                    thunkDispatch(errored); 
                })


        }); 
    },
    GetDistrictReport(divisionNumber, districtNumber, auditType, dateRange) { 
        dispatch((thunkDispatch) => {

            const loading = events.GetDistrictReport.New();

            thunkDispatch(loading);

            const url = `reports/audit-district-reporting?divisionNumber=${divisionNumber}&districtNumber=${districtNumber}&auditType=${auditType}&dateRange=${dateRange}`;

            server.Get(url)
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    const loaded = events.GotDistrictReport.New(json);

                    thunkDispatch(loaded);
                })
                .catch((ex) => {
                    const errored = events.ErroredGetDistrictReport.New(ex);

                    thunkDispatch(errored);
                })
        }); 
    }, 
    ClearCompletionReport() {
        dispatch((thunkDispatch) => { 
            const loading = events.ClearCompletionReport.New();

            thunkDispatch(loading); 
        })
    }, 
    LoadCompletedAudits(divisionNumber, districtNumber) {
        dispatch((thunkDispatch) => {
            const loading = events.CompletedAuditsLoading.New();

            thunkDispatch(loading);

            const url = `reports/audit-completion-counts?divisionNumber=${divisionNumber}&districtNumber=${districtNumber}`;

            server.Get(url)
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    const loaded = events.CompletedAuditsLoaded.New(json);

                    thunkDispatch(loaded);
                })
                .catch((ex) => {
                    const errored = events.CompletedAuditsErrored.New(ex);

                    thunkDispatch(errored);
                });
        })
    }
};


module.exports = reportDispatchers;


// WEBPACK FOOTER //
// ./src/events/reports/reportDispatchers.js